// Libraries
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * `Capitalize` return First letter with uppercase
 */
@Pipe({name: 'sheCapitalize'})
export class CapitalizePipe implements PipeTransform {
  /**
   * Return value date.
   * @param date Data to transform
   * @return First letter with uppercase
   */
  transform(date: string): string {
    return _.capitalize(date);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/capitalize.pipe.ts